export const gtmParams = {
    id: 'GTM-NCZXSZ',
};
